module.exports = require("core-js-pure/stable/instance/find");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/find.js
// module id = 2865
// module chunks = 25